import { UPDATE_SETTING_FIELD } from 'constants/actions';
import { MY_RECENT } from 'constants/feedListingTypes';
import { GRID_SIZE, FEED_TYPE } from 'constants/settingsFields';

const initialState = {
  [GRID_SIZE]: 6,
  [FEED_TYPE]: MY_RECENT,
};

export default function settings(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_SETTING_FIELD:
      return {
        ...state,
        [action.field]: action.value,
      };
    default:
      return state;
  }
}
